import React from "react";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";

interface LinkProps {
  to?: string;
  href?: string;
  children: React.ReactNode;
  className?: string;
}

const StyledLink = styled.a`
  font-size: calc(12px + 2vmin);
  text-decoration: none;
  color: inherit;
  display: block;
  
  &:visited {
    color: inherit;
  }

  &:hover {
    transform: translateY(-5px);
    opacity: 0.8;
    text-decoration: underline;
  }
`;

const StyledRouterLink = styled(RouterLink)`
  font-size: calc(12px + 2vmin);
  text-decoration: none;
  color: inherit;
  display: block;
  
  &:visited {
    color: inherit;
  }

  &:hover {
    transform: translateY(-5px);
    opacity: 0.8;
    text-decoration: underline;
  }
`;

const Link: React.FC<LinkProps> = ({ to, href, children, className }) => {
  if (to) {
    return (
      <StyledRouterLink to={to} className={className}>
        {children}
      </StyledRouterLink>
    );
  }
  
  return (
    <StyledLink href={href} className={className}>
      {children}
    </StyledLink>
  );
};

export default Link;